export const ARS_CURRENCY = new Intl.NumberFormat('es-AR', {
  style: 'currency',
  currency: 'ARS',
  maximumFractionDigits: 2,
});

export const formatARS = (value) => ARS_CURRENCY.format(Number(value || 0));

export const formatDateAR = (value) => {
  if (!value) return '—';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '—';
  return parsed.toLocaleDateString('es-AR', {
    timeZone: 'America/Argentina/Buenos_Aires',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

export const parseDateInput = (value) => {
  if (!value) return '';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '';
  const year = parsed.getFullYear();
  const month = `${parsed.getMonth() + 1}`.padStart(2, '0');
  const day = `${parsed.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const nowDateInput = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = `${now.getMonth() + 1}`.padStart(2, '0');
  const day = `${now.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const firstDayOfMonthInput = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = `${now.getMonth() + 1}`.padStart(2, '0');
  return `${year}-${month}-01`;
};

export const isDateWithinRange = (dateValue, from, to) => {
  if (!dateValue) return false;
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return false;

  const fromDate = from ? new Date(`${from}T00:00:00`) : null;
  const toDate = to ? new Date(`${to}T23:59:59`) : null;

  if (fromDate && date < fromDate) return false;
  if (toDate && date > toDate) return false;
  return true;
};

export const resolveCashierId = (entry = {}) => (
  entry.userId
  || entry.user_id
  || entry.userID
  || entry.cashier_id
  || entry.cashierId
  || entry.opened_by
  || entry.closed_by
  || entry.operator_id
  || entry.cashier?.userId
  || entry.cashier?.user_id
  || entry.cashier?.id
  || entry.cashier?._id
  || entry.user?.id
  || entry.user?._id
  || null
);

export const resolveCashierName = (cashierId, usersMap) => {
  if (!cashierId) return 'Sin cajero';
  const found = usersMap.get(cashierId);
  if (!found) return cashierId;
  const fullName = [found.name, found.last_name].filter(Boolean).join(' ').trim();
  return fullName || found.email || cashierId;
};

export const round2 = (value) => Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;
